// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-create-new-js": () => import("./../../../src/pages/createNew.js" /* webpackChunkName: "component---src-pages-create-new-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-show-lolly-js": () => import("./../../../src/pages/showLolly.js" /* webpackChunkName: "component---src-pages-show-lolly-js" */)
}

